/**
 * Enums for table sort directions
 */
export enum TABLE_SORT_DIRECTIONS {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

/**
  GraphQL Enums for sorting with page info
  */
export enum SORT_DIRECTIONS {
  ASCENDING = 'Ascending',
  DESCENDING = 'Descending',
}

type TableGqlSortDirectionEnumMap = {
  [k in SORT_DIRECTIONS]: TABLE_SORT_DIRECTIONS;
} & {
  [k in TABLE_SORT_DIRECTIONS]: SORT_DIRECTIONS;
};

/**
 * Maps our table sorting directions to gql sorting for queries and vice versa
 */
export const TABLE_GQL_SORT_DIRECTION_ENUM_MAP: TableGqlSortDirectionEnumMap = {
  [TABLE_SORT_DIRECTIONS.ASCENDING]: SORT_DIRECTIONS.ASCENDING,
  [TABLE_SORT_DIRECTIONS.DESCENDING]: SORT_DIRECTIONS.DESCENDING,
  [SORT_DIRECTIONS.ASCENDING]: TABLE_SORT_DIRECTIONS.ASCENDING,
  [SORT_DIRECTIONS.DESCENDING]: TABLE_SORT_DIRECTIONS.DESCENDING,
};
